// src/pages/ELearning.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

export default function ELearning() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-purple-700 to-blue-800 text-white p-10">

      <h1 className="text-4xl font-bold mb-10">E-Learning</h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full max-w-3xl">

        {/* Pre-Primary */}
        <button
          onClick={() => navigate("/pre-primary")}
          className="p-6 text-xl font-semibold bg-yellow-400 hover:bg-yellow-500 
                     text-black rounded-2xl shadow-lg"
        >
          Pre-Primary
        </button>

        {/* Primary */}
        <button
          onClick={() => navigate("/primary")}
          className="p-6 text-xl font-semibold bg-green-500 hover:bg-green-600 
                     text-black rounded-2xl shadow-lg"
        >
          Primary
        </button>

        {/* Upper Primary */}
        <button
          onClick={() => navigate("/upper-primary")}
          className="p-6 text-xl font-semibold bg-blue-500 hover:bg-blue-600 
                     text-white rounded-2xl shadow-lg"
        >
          Upper-Primary
        </button>

      </div>
    </div>
  );
}









